import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { CircularProgress, Box } from '@mui/material';
import { components } from 'react-select';

// ✅ Custom SingleValue to show only the name
const CustomSingleValue = (props) => {
  const { data } = props;
  return <components.SingleValue {...props}> <span style={{ color: 'white' }}>{data.name}</span></components.SingleValue>;
};

const AsyncSelectSearch = ({
  onSearch,
  renderOption,
  onSelectResult,
  placeholder = 'Type to search...',
  loadingComponent = <CircularProgress size={20} />,
  selectStyles = {},
  required = false,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);

  const loadOptions = async (input) => {
    if (!input || input.length < 3 || !onSearch) {
      return [];
    }
    try {
      const data = await onSearch(input);
      return data || [];
    } catch (e) {
      console.error('Search error:', e);
      return [];
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedValue(selectedOption);
      setInputValue('');
      onSelectResult?.(selectedOption);
    } else {
      setSelectedValue(null);
      setInputValue('');
      onSelectResult?.(null);
    }
  };

  const handleInputChange = (newValue, { action }) => {
    if (action === 'input-change') {
      setInputValue(newValue);
      if (!newValue) {
        setSelectedValue(null);
      }
    }
    return newValue;
  };

  const handleBlur = () => {
    if (inputValue && !selectedValue) {
      const freeTextOption = { name: inputValue };
      setSelectedValue(freeTextOption);
      onSelectResult?.(freeTextOption);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 56,
      border: '3px solid',
      borderColor: state.isFocused ? '#1976d2' : '#999',
      boxShadow: 'none',
      backgroundColor: 'transparent', // Transparent like CssTextField
      '&:hover': {
        borderColor: '#1976d2',
      },
      borderRadius: 4,
      ...selectStyles.control,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: 'white',
      border: '1px solid #ccc',
      borderRadius: 4,
      ...selectStyles.menu,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#1976d2'
        : state.isFocused
        ? '#333'   // Dark background on hover
        : '#222',  // Default dark background
      color: 'white',  // Make all option text white
      cursor: 'pointer',
      ...selectStyles.option,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#999',
    }),
    singleValue: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
      color: '#000',
    }),
    input: (provided) => ({
      ...provided,
      color: 'white',
    }),
  };

  return (
    <Box sx={{ width: '100%' }}>
      <AsyncSelect
        cacheOptions={false}
        loadOptions={loadOptions}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onBlur={handleBlur}
        inputValue={inputValue}
        value={selectedValue}
        placeholder={placeholder}
        isClearable
        noOptionsMessage={() => 'No results'}
        loadingMessage={() => loadingComponent}
        getOptionLabel={(option) => option.name || ''}
        getOptionValue={(option) => option.id || option.name || JSON.stringify(option)}
        formatOptionLabel={renderOption}
        styles={customStyles}
        components={{ SingleValue: CustomSingleValue }} // ✅ override selected value renderer
        required={required}
      />
    </Box>
  );
};

export default AsyncSelectSearch;
